class TryOnEnums {
  constructor(){
    this.UPLOAD_IMAGE="upload image";
    this.SELECT_MODEL="select a model";
    this.LIVE_CAMERA="live camera";
    this.LIPSTICK = "LIPSTICK";
    this.CONCEALER = "CONCEALER";
    this.FOUNDATION="FOUNDATION";
    this.MAKEOVER="MAKEOVER";

    this.EYESHADOW = "EYESHADOW";
    this.EYELINER = "EYELINER";
    this.EYELASH = "EYELASH";
    this.LIPGLOSS = "LIPGLOSS";
    this.BLUSH = "BLUSH";
    this.BRONZER = "BRONZER";
    this.HIGHLIGHTER = "HIGHLIGHTER";
    this.EYEBROW = "EYEBROW";

    this.FROM_MAIN_TRYON="Main Tryon";
    this.FROM_MAIN_TRYON_CONTENT="Main Tryon Content";

    this.CURRENT_TRYON = "";
    this.VIDEO_WIDTH = 1080;
    this.VIDEO_HEIGHT = 720;
    this.OUTPUT_CANVAS_WIDTH_MOBILE = 450;
    this.OUTPUT_CANVAS_WIDTH_DESKTOP = 800;
    this.VIDEO_IDEAL_FRAME_RATE = 50;
    this.VIDEO_MAX_FRAME_RATE = 60;
    
    this.SECRET_PERFECTOR="Products/Secret-Perfector";
    this.SECRET_PERFECTOR_SINGLE_PRODUCT="Products/Secret-Perfector-";
    this.MOLTEN_MATTE_LIQUID="Products/Molten-Matte-Liquid-Lipstick";
    this.SILK_SUEDE_LIPSTICK="Products/Silk-Suede-Lipstick";
    this.LIQUID_MAGIC_CONCEALER="Products/Liquid-Magic-Concealer";
    
    this.POWER_PLAY_FOUNDATION="Products/Power-Play-Foundation";
    this.MONOCHROMATIC_LIP_BLUSH_SET="Products/Monochromatic-Lip-Blush-Set";
    this.MONOCHROMATIC_LIP_COLOR="Products/Monochromatic-Lip-Color";
    this.MONOCHROMATIC_BLUSH_DUO="Products/Monochromatic-Blush-Duo";
    
    this.FACE_IT = "products/face-it";
    this.BLEND_IT = "products/blend-it";
    this.COLOR_IT = "products/color-it";
    this.GLOSS_IT = "products/gloss-it";
    
    
    this.CONTOUR = "CONTOUR";
  }
  
     }
    if(window.TryOnEnums === undefined) {
    window.TryOnEnums = new TryOnEnums();
}